const Style = {

  panel:       'absolute top-[calc(100%+8px)] right-0 z-[200] bg-white border border-gray-200 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] w-[300px] p-5',
  section:     'mb-5',
  sectionLast: 'mb-1',
  label:       'text-[11px] font-semibold text-gray-500 uppercase tracking-[0.06em] mb-2',
  pillGroup:   'flex gap-1.5 flex-wrap',
  pill:        'px-3.5 py-1 rounded-full text-[13px] font-medium cursor-pointer transition-all duration-100 border',
  pillDefault: 'border-gray-200 bg-gray-100 text-gray-700 hover:border-gray-300',
  pillActive:  'border-blue-600 bg-blue-50 text-blue-600',
  dateGroup:   'flex flex-col gap-2',
  dateRow:     'flex items-center gap-2',
  dateRowLabel:'text-xs text-gray-400 w-7 shrink-0',
  dateInput:   'w-full h-8 px-2.5 border border-gray-200 rounded-md text-[13px] text-gray-700 outline-none box-border',
  footer:      'flex items-center justify-between mt-6',
  clearBtn:    'bg-transparent border-none p-0 text-[13px] text-gray-500 cursor-pointer underline',
  applyBtn:    'bg-blue-600 text-white border-none rounded-lg px-5 py-2 text-sm font-medium cursor-pointer hover:bg-blue-700',

}

export default Style;
